import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AiTopicComponent } from './ai-topic/ai-topic.component';

const routes: Routes = [
  {
    path: '',
    component: AiTopicComponent,
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AiTopicSettingsRoutingModule { }
